import { useTranslation } from 'react-i18next'
import { AnimatedSection } from '@/components/shared/AnimatedSection'
import { getImageUrl } from '@/lib/image-url'

export function WelcomeSection() {
  const { t } = useTranslation()

  return (
    <section id="welcome" className="bg-white py-24">
      <div className="mx-auto max-w-7xl px-10">
        <div className="flex flex-col items-stretch gap-0 lg:flex-row">
          {/* Image column — arch/tombstone shape, 1/3 width */}
          <AnimatedSection className="flex shrink-0 justify-center pb-10 lg:w-[380px] lg:pb-0 lg:pr-14">
            <div
              className="h-[480px] w-full max-w-[320px] bg-cover bg-center lg:h-full lg:max-w-none"
              style={{
                backgroundImage: `url(${getImageUrl('/images/nuva/staff/staff-placeholder.jpg')})`,
                borderRadius: '300px 300px 0px 0px',
                minHeight: '420px',
              }}
              role="img"
              aria-label="Hotel Boutique Nueva Valladolid — Comayagua, Honduras"
            />
          </AnimatedSection>

          {/* Text column — 2/3 width */}
          <AnimatedSection delay={0.15} className="flex flex-col justify-center lg:flex-1">
            <p
              className="mb-3 text-sm font-bold uppercase tracking-widest"
              style={{ color: '#0F2966' }}
            >
              Hotel Boutique Nueva Valladolid
            </p>

            <h2
              className="font-montserrat text-3xl font-bold uppercase leading-tight"
              style={{ color: '#0F2966' }}
            >
              {t('welcome.title', 'Un Refugio Corporativo en el Corazón Histórico de Comayagua')}
            </h2>

            <p className="mt-6 text-base leading-relaxed" style={{ color: '#666666' }}>
              {t(
                'welcome.description',
                'Ubicado en el Barrio Abajo del centro histórico de Comayagua, el Hotel Boutique Nueva Valladolid ofrece un entorno sereno y profesional diseñado para viajeros corporativos. Habitaciones silenciosas con áreas de trabajo privadas, salas de reuniones totalmente equipadas, jardines interiores, piscina y servicio personalizado para estadías productivas.',
              )}
            </p>

            <p className="mt-4 text-base leading-relaxed" style={{ color: '#666666' }}>
              {t(
                'welcome.history',
                'En la ciudad colonial mejor conservada de Honduras, fundada en 1537, nuestro hotel combina arquitectura histórica con todas las comodidades modernas para crear el equilibrio perfecto entre confort y productividad.',
              )}
            </p>

            <div className="mt-8">
              <a
                href="/sobre-nosotros"
                className="inline-flex items-center justify-center font-bold uppercase tracking-wider transition-colors duration-200"
                style={{
                  width: '175px',
                  height: '50px',
                  borderRadius: '100px',
                  backgroundColor: '#0F2966',
                  color: '#FFFFFF',
                  fontSize: '14px',
                  letterSpacing: '0.05em',
                  textDecoration: 'none',
                }}
                onMouseEnter={(e) => {
                  const el = e.currentTarget as HTMLAnchorElement
                  el.style.backgroundColor = '#F3EADB'
                  el.style.color = '#0F2966'
                }}
                onMouseLeave={(e) => {
                  const el = e.currentTarget as HTMLAnchorElement
                  el.style.backgroundColor = '#0F2966'
                  el.style.color = '#FFFFFF'
                }}
              >
                CONOZCA MÁS
              </a>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  )
}
